export default {"src":"/_next/static/media/point-circle.70a4bf9f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};